import ApiService from '@/services/api.service.js';
import store from '@/store/index.js';

export default function useBiGraphRepository() {
  const appsettings = store.state.appSettings;
  const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

  const load = (loadOptions) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/bigraphs/overview${params}`);
  };

  const update = (key, values) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/bigraphs/${key}`, { values: JSON.stringify(values) });

  const updateBulk = async (values) => {
    const payload = values.map((item) => ({ values: JSON.stringify(item) }));
    await ApiService
      .put(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/bigraphs/bulk`, payload);
  };

  return {
    load,
    update,
    updateBulk,
  };
}
